import React, { useEffect, useState } from 'react';
import { ClubProps } from './club.interface';
import { getDataClub } from '../../API/clubs';
import { ClubData } from '../../API/clubs/club.interface';
import { useDispatch } from 'react-redux';
import { setClub } from '../../../redux/club/actions';
import { AxiosResponse } from 'axios';
import { Redirect } from 'react-router-dom';

/*
 * Lógica de parkeo
 */

const ClubHandler = ({ children }: ClubProps): JSX.Element => {
  const [codeError, setCodeError] = useState<number>();

  const dispatch = useDispatch();
  useEffect(() => {
    getDataClub(getSubdomainClub())
      .then((res: AxiosResponse<ClubData>) => {
        const clubData = res.data.data;
        if (clubData.landingPageSetting.active) dispatch(setClub(clubData));
        else {
          setCodeError(403);
        }
      })
      .catch(error => {
        setCodeError(error.response.status);
      });
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (codeError === 404) return <Redirect to="/404" />;
  if (codeError === 403) return <Redirect to="/inactive" />;

  return <>{children}</>;
};

export default ClubHandler;

/**
 * getSubdomainClub
 * @description Returns the subdomain of the club (the subdomain is the value by which the club is identified)
 * @returns {string}
 */
export const getSubdomainClub = (): string => {
  let subdomainClub: string;
  if (window.location.hostname.indexOf('localhost') !== -1) {
    subdomainClub = process.env.REACT_APP_SUBDOMAIN ? process.env.REACT_APP_SUBDOMAIN : '';
  } else {
    const parts = window.location.hostname.split('.');
    //1°: Verifico si tiene subdominio
    if (parts.length >= 3) {
      const subdomain = parts[0];
      //2°: Verifico que el subdominio sea "www", "club", "beneficios" o "descuentos"
      if (
        [
          'www',
          'club',
          'beneficios',
          'tarjeta',
          'descuentos',
          'cloud',
          'clubconductores',
          'puntos',
          'recompensas',
          'rewards',
          'cgpremia',
        ].includes(subdomain)
      ) {
        // Quiere decir que entra con el dominio del cliente pero con wwww o algún de esos subdominios, ej: www.clubexample.com, beneficios.clubexample.com
        subdomainClub = parts[1];
      } else {
        // Quiere decir que el subdominio tiene el nombre del club, ej: clubexample.misistemanube.com
        subdomainClub = subdomain;
      }
    } else {
      // Si no tiene, debe venir algo como esto: clubexample.com (dominio del cliente apuntando a nuestro servidor)
      subdomainClub = parts[0];
    }
  }

  return subdomainClub;
};
